import React from 'react';
import { useFulfillmentDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/fulfillmentDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { getFulfillmentBarColor } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/FulfillmentDashboard.constants';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const FulfillmentByPositionChart: React.FC = () => {
  const data = useFulfillmentDashboardStore((s) => s.fulfillmentByPosition);
  const page = useFulfillmentDashboardStore((s) => s.fulfillmentByPositionPage);
  const totalPages = useFulfillmentDashboardStore((s) => s.fulfillmentByPositionTotalPages);
  const loadingMore = useFulfillmentDashboardStore((s) => s.fulfillmentByPositionLoadingMore);
  const loadMore = useFulfillmentDashboardStore((s) => s.loadMoreFulfillmentByPosition);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  const items: HorizontalBarItem[] = data.map((d) => {
    const color = getFulfillmentBarColor(
      d.fulfillmentPercentage,
      palette.chartColors,
      palette.threshold,
    );
    const percentage = formatDashboardNumber(d.fulfillmentPercentage);
    return {
      label: d.position,
      value: d.fulfillmentPercentage,
      valueLabel: `${percentage}% (${d.totalShifts} shifts)`,
      ariaLabel: `${d.position}: ${percentage}% (${d.totalShifts} shifts)`,
      tooltipHtml: `<strong>${d.position}</strong><br/>Fulfillment: ${percentage}%<br/>Shifts: ${d.totalShifts}`,
      barColor: color,
      valueLabelColor: color,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      maxValue={100}
      leftMargin={170}
      wrapLabels
      scrollable
      ariaLabel="Fulfillment by position chart"
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
